import { SET_UOM_DATA } from "../actions/types";
const initialState = {
	uomJsonMap: [],
	productUOM: [],
	netweightUOM: [],
	serviceUOM: []
};
export default (state = initialState, action) => {
	const payload = action.payload;  
	switch (action.type) {
		case SET_UOM_DATA: {
			let newState = {
				...state
			};
			newState.uomJsonMap = payload.uomJsonMap;
			newState.productUOM = payload.productUOM;
			newState.netweightUOM = payload.netweightUOM;
			newState.serviceUOM = payload.serviceUOM;
			return newState;
		}
		default:
			return state;
	}
};